module.exports = "bundles/c635a8ce7938917d96631939b728fef9.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/pie-charts/pie-chart-20.png
// module id = 129
// module chunks = 0